export const OfferMode = {
    EDIT: "EDIT",
    PLACED: "PLACED"
}
